import { FlexView } from '@cuemath/comps';
import styled from 'styled-components';

export const CompactInputWrapper = styled(FlexView)`
  height: 44px;
`;
